import React, { Component } from "react";
import { Button, Glyphicon } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { API } from "aws-amplify";

import "./HabitLabel.css";

const red = 'rgba(204, 51, 63, ';
const orange = 'rgba(233, 127, 2, ';
const yellow = 'rgba(248, 202, 0, ';
const green = 'rgba(138, 155, 15, ';
const blue = 'rgba(3, 54, 73, ';
const purple = 'rgba(73, 10, 61, ';

class HabitLabel extends Component {

  constructor(props) {
    super(props);

    var state = {}
    for (var i = 0; i < this.props.habit.days.values.length; i++) {
      var day = this.props.habit.days.values[i];
      state[day] = 'selected';
    }
    state['isHovered'] = false;
    state['isSettingsHovered'] = false;

    this.handleHover = this.handleHover.bind(this);
    this.handleSettingsHover = this.handleSettingsHover.bind(this);
    this.handleHabitClick = this.handleHabitClick.bind(this);

    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);

    this.state = state;
  }

  getColorPickerStyle(color) {
    var style = {
      'backgroundColor': color + ".7)",
    }
    if (this.props.habit.color == color) {
      style['border'] = '1px solid white',
      style['boxShadow'] = '0 0 0 2px ' + color + ".7)"
    }
    return style;
  }

  draggedStyle() {
    // const style = {
    // 'borderLeft': '1px solid rgba(115,115,115, .6)',
    // }
    // if ((this.props.habitDragged == this.props.habit.habitId) && this.props.isTableHovered && this.props.mouseIsDown) {
    //   return style;
    // }

    const destinationDragStyle = {
      'left': '-10px',
      //'borderLeft': '1px solid rgba(115,115,115, .6)'
    };
    if (this.props.habitDragged != null && this.state.isHovered && !this.state.isSettingsHovered) {
      return destinationDragStyle;
    }

    return null;
  }

  render() {
    const btnClass = this.state.isHovered ? "selected" : "";
    const divStyle = {
      'color': this.props.habit.color + ".5)",
      'position': 'absolute',
      'bottom': '5px',
      'right': '5px',
      'fontSize': '9px',
      'fontWeight': '700'
    }
    const colorPickerWrapperStyle = {
      'position': 'absolute',
      'bottom': '5px',
      'left': '5px',
      'fontSize': '9px',
      'display': 'inline-block'
    }

    const settingsButtonStyle = {
      'position': 'absolute',
      'top': '5px',
      'left': '3px',
      'fontSize': '16px',
      'color': 'rgba(115,115,115, .9)',
      'display': 'inline-block'
    }

    const arrowDragButtonStyle = {
      'position': 'absolute',
      'top': '25px',
      'left': '5px',
      'fontSize': '20px',
      'color': 'rgba(115,115,115, .9)',
      'display': 'none'
    }

    if (!this.state.isHovered || this.props.habitDragged != null) {
      colorPickerWrapperStyle['display'] = 'none';
      settingsButtonStyle['display'] = 'none';
    }

    if (!this.state.isSettingsHovered) {
      settingsButtonStyle['color'] = 'rgba(115,115,115, .5)';
    }

    if (this.props.habitDragged != null && this.state.isHovered && !this.state.isSettingsHovered) {
      arrowDragButtonStyle['display'] = 'inline-block';
    }

    return (
      <td
        onMouseEnter={ this.handleHover }
        onMouseLeave={ this.handleHover }
        onMouseDown={ this.handleMouseDown }
        onMouseUp={ this.handleMouseUp }
        onMouseMove={ this.handleMouseMove }
        className={"HabitLabel " + btnClass}
        style = { this.draggedStyle() }
        >
          <div className="HabitName"
            >
            {this.props.habit.content}
          </div>
          <div
            onClick={this.handleHabitClick}
            className="settingsButton"
            style={ settingsButtonStyle }
            onMouseEnter={ this.handleSettingsHover }
            onMouseLeave={ this.handleSettingsHover }
          >
            <Glyphicon glyph="pencil" />
          </div>
          <div
            onClick={this.handleHabitClick}
            className="arrowDragButton"
            style={ arrowDragButtonStyle }
          >
            <Glyphicon glyph="resize-vertical" />
          </div>
          <div style={ divStyle }>
            <span className={ this.state.Sunday ? "" : "notSelected" }>S</span>
            <span className={ this.state.Monday ? "" : "notSelected"  }> M</span>
            <span className={ this.state.Tuesday ? "" : "notSelected"  }> T</span>
            <span className={ this.state.Wednesday ? "" : "notSelected"  }> W</span>
            <span className={ this.state.Thursday ? "" : "notSelected"  }> T</span>
            <span className={ this.state.Friday ? "" : "notSelected"  }> F</span>
            <span className={ this.state.Saturday ? "" : "notSelected"  }> S</span>
          </div>
          <div style={ colorPickerWrapperStyle }>
            <div style={ this.getColorPickerStyle(red) }
                 onMouseDown={(e) => this.handleMouseDownLabel(e) }
                 onClick={(e) => this.handleColorSchemeChange(e, red) }
                 className="colorPicker">
            </div>
            <div style={ this.getColorPickerStyle(orange) }
                 onMouseDown={(e) => this.handleMouseDownLabel(e) }
                 onClick={(e) => this.handleColorSchemeChange(e, orange)}
                 className="colorPicker">
            </div>
            <div style={ this.getColorPickerStyle(yellow) }
                 onMouseDown={(e) => this.handleMouseDownLabel(e) }
                 onClick={(e) => this.handleColorSchemeChange(e, yellow)}
                 className="colorPicker">
            </div>
            <div style={ this.getColorPickerStyle(green) }
                 onMouseDown={(e) => this.handleMouseDownLabel(e) }
                 onClick={(e) => this.handleColorSchemeChange(e, green)}
                 className="colorPicker">
            </div>
            <div style={ this.getColorPickerStyle(blue) }
                 onMouseDown={(e) => this.handleMouseDownLabel(e) }
                 onClick={(e) => this.handleColorSchemeChange(e, blue)}
                 className="colorPicker">
            </div>
            <div style={ this.getColorPickerStyle(purple) }
                 onMouseDown={(e) => this.handleMouseDownLabel(e) }
                 onClick={(e) => this.handleColorSchemeChange(e, purple)}
                 className="colorPicker">
            </div>
          </div>
      </td>
    );
  }

  handleMouseDown() {
    this.props.handleDrag(this.props.habit.habitId);
  }

  handleMouseUp() {
    this.props.handleDragDrop(this.props.habit.habitId);
  }

  handleMouseDownLabel(e) {
    e.stopPropagation();
    this.props.handleMouse();
  }

  async handleColorSchemeChange(e, color) {
    e.stopPropagation();
    var habit = JSON.parse(JSON.stringify(this.props.habit));;
    habit['color'] = color;
    if (habit.days) {
      habit['days'] = habit.days.values;
    }
    if (habit.marks) {
      habit['marks'] = habit.marks.values;
    }
    this.props.updateColor(color);
    await this.saveHabit(habit);
  }

  saveHabit(habit) {
    return API.put("habits", `/habits/${habit.habitId}`, {
      body: habit
    });
  }

  handleHabitClick = event => {
    event.preventDefault();
    this.props.history.push(`/habits/${this.props.habit.habitId}`);
  }

  handleHover() {
    if (this.props.habitDragged != null && !this.state.isHovered && this.props.mouseIsDown
       && (this.props.habitDragged != this.props.habit.habitId)) {
      var from = this.props.habit.habitId;
      var to = this.props.habitDragged;
      this.props.handleHoverMove(to, from);
    }
    this.setState({
      isHovered: !this.state.isHovered
    });
  }

  handleSettingsHover() {
    this.setState({
      isSettingsHovered: !this.state.isSettingsHovered
    })
  }
}

export default withRouter(HabitLabel);



// WEBPACK FOOTER //
// ./src/containers/HabitLabel.js